import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, useStore } from "@nuxtjs/composition-api";

import { useFeatureDetection, useI18n, useLinkService } from "@/composables";
import { useCartsStore } from "@/store";
import { getProductDetailsStore } from "@/store/product-details";
import { toCurrency } from "@/utils/transform/text";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartItemsListItem',
  props: {
  cartItemId: {
    type: String,
    required: true,
  },
},
  emits: ["delete", "update"],
  setup(__props, { emit }: { emit: ({
  (e: "delete", cartItemId: string): void;
  (e: "update", params: { cartItemId: string; quantity: number }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const { cartItemId } = toRefs(props);

const featureDetection = useFeatureDetection();
const i18n = useI18n();
const linkService = useLinkService();
const store = useStore();
const cartsStore = useCartsStore();
const productDetailsStore = getProductDetailsStore(store);

const cartItem = computed(() => {
  return cartsStore.cartItems[cartItemId.value];
});

const productDetails = computed(() => {
  return productDetailsStore.productDetails[cartItem.value?.productDetailsId ?? ""];
});

const retailerProduct = computed(() => {
  return cartsStore.catalogRetailerProducts[productDetails.value?.catalogRetailerProductId ?? ""];
});

const retailerProductVariant = computed(() => {
  return cartsStore.retailerProductVariants[cartItem.value?.retailerProductVariantId ?? ""];
});

const linkUrl = computed(() => {
  if (!cartItem.value) {
    return "";
  }
  const { productDetailsId, contentSourceType, clickHash, contentSourceId, retailerProductVariantId } = cartItem.value;
  return linkService.getProductDetailsLink({
    productDetailsId,
    ...(contentSourceType === "post" && { ltkId: contentSourceId }),
    ...(contentSourceType === "product_set" && { productSetId: contentSourceId }),
    ...(contentSourceType === "off_property" && { rshash: clickHash }),
    variantId: retailerProductVariantId,
  });
});

const imageProps = computed(() => {
  if (!retailerProduct.value) {
    return null;
  }
  const imageUrl = linkService.getImageLink({
    url: retailerProduct.value.imageUrl,
    width: "80",
    height: "80",
    useDefaultDpr: false,
  });
  return {
    src: imageUrl + `&dpr=${featureDetection.dpr}`,
    srcSet: `${imageUrl}&dpr=1 1x, ${imageUrl}&dpr=2 2x, ${imageUrl}&dpr=3 3x`,
    width: 88,
    height: 88,
    crossorigin: false,
    rounded: true,
  };
});

const title = computed(() => {
  return retailerProduct.value?.title ?? "";
});

const details = computed(() => {
  return retailerProductVariant.value?.title ?? "";
});

const price = computed(() => {
  if (!retailerProductVariant.value) {
    return "";
  }
  return toCurrency(retailerProductVariant.value.price, { locales: i18n.locale, currency: "USD" });
});

const salePrice = computed(() => {
  if (!retailerProductVariant.value || !retailerProductVariant.value.salePrice) {
    return "";
  }
  const parsedSalePrice = Number(retailerProductVariant.value.salePrice);
  const parsedPriced = Number(retailerProductVariant.value.price);

  if (parsedSalePrice >= parsedPriced) {
    return "";
  }

  return toCurrency(parsedSalePrice, { locales: i18n.locale, currency: "USD" });
});

const quantity = computed(() => {
  return cartItem.value?.quantity;
});

const isSubtractButtonDisabled = computed(() => {
  if (!quantity.value) {
    return true;
  }
  return quantity.value <= 1;
});

const isAvailable = computed(() => {
  return !!retailerProductVariant.value?.availability;
});

const onDeleteCartItem = () => {
  emit("delete", cartItemId.value);
};

const onAddQuantity = () => {
  if (!quantity.value) {
    return;
  }
  emit("update", { cartItemId: cartItemId.value, quantity: quantity.value + 1 });
};

const onSubtractQuantity = () => {
  if (!quantity.value) {
    return;
  }
  emit("update", { cartItemId: cartItemId.value, quantity: quantity.value - 1 });
};

return { __sfc: true,emit, props, cartItemId, featureDetection, i18n, linkService, store, cartsStore, productDetailsStore, cartItem, productDetails, retailerProduct, retailerProductVariant, linkUrl, imageProps, title, details, price, salePrice, quantity, isSubtractButtonDisabled, isAvailable, onDeleteCartItem, onAddQuantity, onSubtractQuantity }
}

})